// extracted by mini-css-extract-plugin
module.exports = {"page":"admin_page__hQLIr","container":"admin_container__2g2kw","footer":"admin_footer__3WFO4"};